import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Image from "gatsby-image"

import { Row, Col, Card, InputGroup, FormControl } from "react-bootstrap"

export let LogoSection = props => {
  return (
    <>
      <Row style={{ justifyContent: "center" }}>
        <SecondTitle>Organiza</SecondTitle>
      </Row>
      <Row style={{ justifyContent: "center", paddingBottom: "4rem" }}>
        <Col xl={2} lg={2} md={4} sm={6} xs={6}>
          <Image fluid={props.logoClever} alt="Cleverit Group"></Image>
        </Col>

        {props.support && (
          <Row style={{ justifyContent: "center" }}>
            <SecondTitle>{props.support}</SecondTitle>
          </Row>
        )}

        {props.altCompanyOne && (
          <Col xl={2} lg={2} md={4} sm={6} xs={6}>
            <Image
              fluid={props.logoCompanyOne}
              alt={props.altCompanyOne}
            ></Image>
          </Col>
        )}
      </Row>
      <Row style={{ justifyContent: "center" }}>
        {props.disclaimer && <p>{props.disclaimer}</p>}
      </Row>
    </>
  )
}

const SecondTitle = styled.h2`
  font-family: "Open Sans", sans-serif;
  font-weight: 800;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;

  @media (max-width: 900px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`
export default LogoSection
